import { useLingui } from "@lingui/react/macro";
import { useFormContext, type FieldValues } from "react-hook-form";
import RadioButton from "@medoma/components/RadioButton/RadioButton";
import RadioButtons from "@medoma/components/RadioButton/RadioButtons";
import {
  useFieldPathWithPrefix,
  useFieldErrorWithPrefix,
} from "@/forms/FormFieldPathPrefixContext";
import {
  batchTemplateActivityInclusionTypeSchema,
  type BatchTemplateActivityFormFields,
} from "@/pages/template-manager/BatchTemplateForm/batchTemplateFormSchema";

export const BatchTemplateActivityInclusionPicker = () => {
  const { t } = useLingui();
  const {
    formState: { errors },
    register,
  } = useFormContext<FieldValues>();

  const inclusionTypeFieldName =
    useFieldPathWithPrefix<BatchTemplateActivityFormFields>("inclusionType");
  const errorMessage = useFieldErrorWithPrefix<BatchTemplateActivityFormFields>(
    errors,
    "inclusionType",
  );

  const inclusionTypeField = register(inclusionTypeFieldName, {
    required: {
      value: true,
      message: t`Välj visningsalternativ`,
    },
  });

  return (
    <RadioButtons
      legend={t`Visningsalternativ`}
      errorMessage={errorMessage}
      orientation="horizontal"
    >
      <RadioButton
        label={{ text: t`Förvald` }}
        visualStyle="framed"
        value={
          batchTemplateActivityInclusionTypeSchema.enum
            .optionalWithDefaultSelected
        }
        {...inclusionTypeField}
      />
      <RadioButton
        label={{ text: t`Ej förvald` }}
        visualStyle="framed"
        value={batchTemplateActivityInclusionTypeSchema.enum.optional}
        {...inclusionTypeField}
      />
    </RadioButtons>
  );
};
